/**
 * Single source of truth for the conversation the user currently has OPEN in
 * the chat pane.
 *
 * Chat.tsx writes it whenever the active conversation changes; the global
 * notifications hook (useGlobalNotificationsWs, mounted separately in the
 * sidebar) reads it to suppress unread badges / notifications for the chat
 * already on screen.
 *
 * Why a module-level ref instead of the URL: the global hook used to infer the
 * open conversation from the `?open=<id>` query param, but opening a chat by
 * clicking a row in the inbox never writes that param — so a message arriving
 * in the conversation you're actively reading still raised a notification that
 * never cleared. A shared ref is correct regardless of how the chat was opened.
 */
let activeConversationId: string | null = null;

export function setActiveConversationId(id: string | null): void {
  activeConversationId = id;
}

export function getActiveConversationId(): string | null {
  return activeConversationId;
}
